import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionsContext';
import type { PermissionKey } from '../types/permissions';

interface Props {
  permission: PermissionKey;
  children: React.ReactNode;
}

/**
 * Renders children only if the current user holds the given permission.
 * Redirects to /access-denied otherwise (waits for permissions to load first).
 */
export default function PermissionGuard({ permission, children }: Props) {
  const perms = usePermissions();
  if (!perms.ready) return null;
  if (!perms.hasPermission(permission)) return <Navigate to="/access-denied" replace />;
  return <>{children}</>;
}
